import { render, staticRenderFns } from "./GuppyChatWhatsappConversationList.vue?vue&type=template&id=37da896c&"
import script from "./GuppyChatWhatsappConversationList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatWhatsappConversationList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatWhatsappConversationList.vue?vue&type=style&index=0&id=37da896c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports